<div class="share-study-container" *ngIf='opened'>

  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-center">
      <h4 style="margin-bottom: 0; margin-left:29%;">Compartir estudio con su médico</h4>
      <button type="button" style="margin-left: 21%;" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true" style="color: #A3ACBF;">&times;</span>
      </button>
    </div>

    <hr class="hr">

    <div class="card-body p-3">
      <div class="options">

        <div class="option">
          <div class="row">
            <p>Para que su médico pueda ver su estudio, debe acceder desde su navegador a la página
              <a style="color: #f2c63d !important;" [href]="urlBase" target="_blank">{{urlReadable}}</a> e introducir el siguiente código localizador y el dato que se le solicite:</p>
            <p style="color: #f2c63d !important; font-size: large;">{{locator}}</p>
            <p *ngIf="configService.config?.patient_download_instructions">También puede descargar un documento con las instrucciones de acceso adjunto a su informe pulsando <a style="color: #f2c63d !important;" (click)="downloadStudy()">aquí</a></p>
          </div>
          <div class="btn_row">

            <p>Otros métodos para compartir su estudio: </p>

            <!-- Se muestra solamente cuando no se viene redirigido del portal -->
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" (click)="showMailInput()" *ngIf="bookService.temporaryToken==null"
              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="25" height="25"
              viewBox="0 0 122.879 88.855" enable-background="new 0 0 122.879 88.855" xml:space="preserve">
              <g>
                <path class="st1" style="fill: #f2c63d !important;"
                  d="M7.048,0h108.784c1.939,0,3.701,0.794,4.977,2.069c1.277,1.277,2.07,3.042,2.07,4.979v74.759 c0,1.461-0.451,2.822-1.221,3.951c-0.141,0.365-0.361,0.705-0.662,0.994c-0.201,0.189-0.422,0.344-0.656,0.461 c-1.225,1.021-2.799,1.643-4.508,1.643H7.048c-1.937,0-3.701-0.793-4.979-2.07C0.794,85.51,0,83.748,0,81.807V7.048 c0-1.941,0.792-3.704,2.068-4.979C3.344,0.792,5.107,0,7.048,0L7.048,0z M5.406,78.842l38.124-38.22L5.406,9.538V78.842 L5.406,78.842z M47.729,44.045L8.424,83.449h105.701L76.563,44.051L64.18,54.602l0,0c-0.971,0.83-2.425,0.877-3.453,0.043 L47.729,44.045L47.729,44.045z M80.674,40.549l36.799,38.598V9.198L80.674,40.549L80.674,40.549z M8.867,5.406l53.521,43.639 l51.223-43.639H8.867L8.867,5.406z" />
              </g>
            </svg>

            <svg width="25" height="25" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" (click)="showQRImg()"
              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 122.88 122.7"
              style="enable-background:new 0 0 122.88 122.7" xml:space="preserve">
              <g>
                <path style="fill: #f2c63d !important;"
                  d="M0.18,0h44.63v44.45H0.18V0L0.18,0z M111.5,111.5h11.38v11.2H111.5V111.5L111.5,111.5z M89.63,111.48h11.38 v10.67H89.63h-0.01H78.25v-21.82h11.02V89.27h11.21V67.22h11.38v10.84h10.84v11.2h-10.84v11.2h-11.21h-0.17H89.63V111.48 L89.63,111.48z M55.84,89.09h11.02v-11.2H56.2v-11.2h10.66v-11.2H56.02v11.2H44.63v-11.2h11.2V22.23h11.38v33.25h11.02v11.2h10.84 v-11.2h11.38v11.2H89.63v11.2H78.25v22.05H67.22v22.23H55.84V89.09L55.84,89.09z M111.31,55.48h11.38v11.2h-11.38V55.48 L111.31,55.48z M22.41,55.48h11.38v11.2H22.41V55.48L22.41,55.48z M0.18,55.48h11.38v11.2H0.18V55.48L0.18,55.48z M55.84,0h11.38 v11.2H55.84V0L55.84,0z M0,78.06h44.63v44.45H0V78.06L0,78.06z M10.84,88.86h22.95v22.86H10.84V88.86L10.84,88.86z M78.06,0h44.63 v44.45H78.06V0L78.06,0z M88.91,10.8h22.95v22.86H88.91V10.8L88.91,10.8z M11.02,10.8h22.95v22.86H11.02V10.8L11.02,10.8z" />
              </g>
            </svg>

          </div>

          <div class="btn_row" *ngIf="showMail">
            <input class="email_input" placeholder="email"  [(ngModel)]="mail">
            <button class="send_btn" (click)="sendMail()">Enviar</button>
          </div>

          <div class="btn_row" *ngIf="showQR">
            <qrcode [qrdata]="urlBook" [width]="100" [errorCorrectionLevel]="'M'"></qrcode>
          </div>


        </div>


      </div>
    </div>

  </div>

  <app-download-instructions></app-download-instructions>

</div>